import React from 'react';
import './MultiTrackChangeIndicator.scss';

const MultiTrackChangeIndicator = ({ show, onClick }: any) => {
  return (
    <>
      {show ? (
        <div
          className="change-indicator-container"
          title="Undo Change"
          onClick={onClick}
        >
          <i
            className="icon far fa-edit change-indicator"
            aria-hidden="true"
          ></i>
          <i
            className="icon fa fa-rotate-left undo-indicator"
            aria-hidden="true"
          ></i>
        </div>
      ) : null}
    </>
  );
};
export default MultiTrackChangeIndicator;
